// Scene buttons (alarms-and-scenes WEB-SCN-01 to -04): the organisation's manual automations and a refused run in
// words.
import { queryOptions } from "@tanstack/react-query";
import { apiClient, unwrap } from "../../api/client";
import type { components } from "../../api/generated/vision-api";
import { ApiError } from "../../api/problem";
import type { AutomationItem } from "../../widgets/generated/widget-fixture";
import { allPages } from "../devices/queries";

export type Automation = components["schemas"]["AutomationItem"];

/** The widget input's automations, by id. */
export function byId(items: readonly Automation[]): Record<string, AutomationItem> {
  return Object.fromEntries(items.map((a) => [a.id, { name: a.name, enabled: a.enabled, last_ran_at: a.last_ran_at }]));
}

/** Every automation with a manual trigger the person may see, all pages, for the scene buttons' names and last runs. */
export const scenesQuery = (orgId: string, enabled: boolean) =>
  queryOptions({
    queryKey: ["org", orgId, "/v1/automations", "manual"],
    queryFn: async () =>
      byId(
        await allPages((cursor) =>
          unwrap(
            apiClient("customers").GET("/v1/automations", { params: { query: { manual: true, limit: 500, cursor } } }),
          ),
        ),
      ),
    enabled: enabled && !!orgId,
    staleTime: 30_000,
  });

/** A refused run (WEB-SCN-03): permission, turned off or not manual, not built yet, or the API's message. */
export function runError(e: unknown, t: (k: string) => string): string {
  if (!(e instanceof ApiError)) return t("scenes.error.unknown");
  if (e.status === 403) return t("scenes.error.forbidden");
  if (e.status === 404) return t("scenes.notFound");
  if (e.status === 409) return t("scenes.error.disabled");
  if (e.status === 501) return t("scenes.notYet");
  return e.message;
}
